import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaxAttributesComponent } from '../tax-attributes.component';

@Component({
    selector: 'app-tax-attributes-entity-info',
    templateUrl: './tax-attributes-entity-info.component.html',
    styleUrls: ['../tax-attributes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaxAttributesEntityInfoComponent {
  @Input() ctx!: TaxAttributesComponent;
}
